console.warn("CometChat UIKit is not supported on the web.");

export const CometChatMessages = {};
export const CometChatUiKitConstants = {};
export const CometChatUIKit = {};
export const CometChatMessageTemplate = {};
export const CometChatTheme = {};
export const CometChatMessageComposer = {};
export const CometChatMessageHeader = {};
